import React from "react";
import { Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { IHeadingProps } from "./types";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    marginBottom: theme.spacing(2)
  },
  label: {
    display: "flex",
    alignItems: "center"
  },
  gap: {
    flexGrow: 1
  },
  divider: {
    marginBottom: theme.spacing(2)
  }
}));

export const Heading = ({ title, rightAction = null }: IHeadingProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.container}>
        <Typography variant="body1" className={classes.label}>
          {title}
        </Typography>
        <div className={classes.gap} />
        {rightAction}
      </div>
      <Divider className={classes.divider} />
    </>
  );
};
